var bookConfig = {
    "FlipSound": "Yes",
    "QRCode": "Hide",
    "appLogoIcon": "",
    "appLogoLinkURL": "",
    "HomeURL": homeUrl,
    "appLogoOpenWindow": "",
    "bookTitle": "CATALOGUE",
    "bookDescription": "",
    "toolbarColor": "#181818",
    "iconColor": "#eeeeee",
    "loadingPicture": "",
    "loadingCaptionColor": "#0d1d2a",
    "loadingBackground": "#000000",
    "logoHeight": 42,
    "logoTop": 0,
    "logoPadding": 0,
    "HomeButtonVisible": "Show",
    "ShareButtonVisible": "Show",
    "ThumbnailsButtonVisible": "Show",
    "thumbnailAlpha": 70,
    "ZoomButtonVisible": "Show",
    "FullscreenButtonVisible": "Show",
    "TableOfContentButtonVisible": "Show",
    "SearchButtonVisible": "Hide",
    "leastSearchChar": 2,
    "PrintButtonVisible": "Show",
    "printWatermarkFile": "",
    "BookMarkButtonVisible": "Hide",
    "BackgroundSoundButtonVisible": "Hide",
    "BackgroundSoundURL": "",
    "BackgroundSoundLoop": -1,
    "HelpButtonVisible": "Hide",
    "helpContentFileURL": "",
    "helpWidth": 400,
    "helpHeight": 450,
    "showHelpContentAtFirst": "No",
    "aboutButtonVisible": "Hide",
    "aboutContactInfoTxt": "",
    "AutoPlayButtonVisible": "Show",
    "autoPlayAutoStart": "No",
    "SlideshowAutoPlay": false,
    "autoPlayDuration": 3,
    "SlideshowPlayInterval": 5,
    "autoPlayLoopCount": "1",
    "minZoomWidth": 403,
    "minZoomHeight": 518,
    "mouseWheelFlip": "Yes",
    "DownloadButtonVisible": "Show",
    "DownloadURL": "https://disk.yandex.com.tr/i/jjZR3pZsw2vJcQ",
    "UserInforSetting": "",
    "bgBeginColor": "#000000",
    "bgEndColor": "#000000",
    "bgMRotation": 90,
    "backGroundImgURL": "",
    "LeftShadowWidth": 100,
    "LeftShadowAlpha": 1,
    "RightShadowWidth": 40,
    "RightShadowAlpha": 1,
    "pageBackgroundColor": "#FFFFFF",
    "flipshortcutbutton": "Show",
    "OriginPageIndex": 1,
    "RightToLeft": "No",
    "flippingTime": 0.6,
    "retainBookCenter": "Yes",
    "FlipStyle": "Flip",
    "totalPagesCaption": "",
    "pageNumberCaption": "",
    "topMargin": 10,
    "bottomMargin": 10,
    "leftMargin": 10,
    "rightMargin": 10,
    "LinkDownColor": "#0d1d2a",
    "LinkAlpha": 0.4,
    "OpenWindow": "Blank",
    "googleAnalyticsID": "",
    "UIBaseURL": base,
    "language": "English",
    "AboutAddress": "",
    "AboutAuthor": "",
    "AboutEmail": "",
    "AboutMobile": "",
    "AboutWebsite": "",
    "AboutDescription": "",
    "totalPageCount": totalPageCount,
    "pageWidth": 157,
    "pageHeight": 205,
    "largePageWidth": 1575,
    "largePageHeight": 2047,
    "normalPath": pagesLink +"inspiration_tr_large_",
    "largePath": pagesLink +"inspiration_tr_large_",
    "thumbPath": pagesLink +"inspiration_tr_thumb_",
    "VideoButtonVisible": "Hide",
    "SlideshowButtonVisible": "Hide",
    "addPaperCoil": "No",
    "AnnotationButtonVisible": "Hide",
    "CompanyLogoFile": "",
    "bleedAreaLeft": "0%",
    "bleedAreaRight": "0%",
    "bleedAreaTop": "0%",
    "bleedAreaBottom": "0%",
    "HardPageEnable": "No",
    "HardInnerPageEnable": "No",
    "borderColor": "#562e0b",
    "BindingType": "side",
    "hardCoverBorderWidth": "8",
    "outerCoverBorder": "Yes",
    "cornerRound": "8",
    "coverTexture": "none",
    "iconFontColor": "#eeeeee",
    "formBackgroundColor": "#ffffff",
    "formFontColor": "#0d1d2a",
    "backgroundOpacity": "100",
    "autoDoublePage": "Auto",
    "searchKeywordFontColor": "#a3bb92",
    "backgroundPosition": "Stretch",
    "CurlingPageCorner": "Yes",
    "updatePageURL": "True",
    "isTheBookOpen": "No",
    "FlipDirection": "0",
    "InstructionsButtonVisible": "Hide",
    "showInstructionOnStart": "No",
    "showThicknessOnMobile": "No",
    "highDefinitionConversion": "No",
    "pageNumColor": "#111111",
    "backgroundScene": "None",
    "ShowTopLeftShadow": "Yes",
    "maxWidthToSmallMode": 400,
    "maxHeightToSmallMode": 300,
    "hideMiniFullscreen": "No",
    "isStopMouseMenu": "Yes",
    "haveAdSense": "No",
    "adSenseWidth": 200,
    "adSenseHeight": 200,
    "adSenseLeft": 50,
    "adSenseTop": 50,
    "adSenseClientId": "",
    "SelectTextButtonVisible": "Hide",
    "leftRightPnlShowOption": "none",
    "ToolBarAlpha": "1",
    "enablePageBack": "Hide",
    "loadingCaption": "",
    "CreatedTime": 1615423312,
    "searchTextJS": book_config,
    "searchPositionJS": "/scripts/text_position[%d].js"
};
var this_pages = [{
    "l": pagesLink +"inspiration_tr_large_1.jpg",
    "t": pagesLink +"inspiration_tr_thumb_1.jpg"
}, {
    "l": pagesLink +"inspiration_tr_large_2.jpg",
    "t": pagesLink +"inspiration_tr_thumb_2.jpg"
}, {
    "l": pagesLink +"inspiration_tr_large_3.jpg",
    "t": pagesLink +"inspiration_tr_thumb_3.jpg"
}, {
    "l": pagesLink +"inspiration_tr_large_4.jpg",
    "t": pagesLink +"inspiration_tr_thumb_4.jpg"
}, {
    "l": pagesLink +"inspiration_tr_large_5.jpg",
    "t": pagesLink +"inspiration_tr_thumb_5.jpg"
}, {
    "l": pagesLink +"inspiration_tr_large_6.jpg",
    "t": pagesLink +"inspiration_tr_thumb_6.jpg"
}];
var language = [{
    "language": "English",
    "btnFirstPage": "First",
    "btnNextPage": "Next",
    "btnLastPage": "Last",
    "btnPrePage": "Previous",
    "btnGoToHome": "Home",
    "btnDownload": "Download",
    "btnSoundOn": "Sound On",
    "btnSoundOff": "Sound Off",
    "btnPrint": "Print",
    "btnThumb": "Thumbnails",
    "btnBookMark": "Bookmark",
    "frmBookMark": "Bookmark",
    "btnZoomIn": "Zoom In",
    "btnZoomOut": "Zoom Out",
    "btnAutoFlip": "Auto Flip",
    "btnStopAutoFlip": "Stop Auto Flip",
    "btnSocialShare": "Share",
    "btnHelp": "Help",
    "btnAbout": "About",
    "btnSearch": "Search",
    "btnFullscreen": "Fullscreen",
    "btnExitFullscreen": "Exit Fullscreen",
    "btnMore": "More",
    "frmPrintCaption": "Print",
    "frmPrintall": "Print All Pages",
    "frmPrintcurrent": "Print Current Page",
    "frmPrintRange": "Print Range",
    "frmPrintexample": "Example: 2,3,5-10",
    "frmPrintbtn": "Print",
    "frmShareCaption": "Share",
    "frmShareLabel": "Share",
    "frmShareInfo": "You can easily share this publication to social networks.Just click the appropriate button below",
    "frminsertLabel": "Insert to Site",
    "frminsertInfo": "Use the code below to embed this publication to your website.",
    "frmaboutcaption": "Contact",
    "frmaboutcontactinformation": "Contact Information",
    "frmaboutADDRESS": "Address",
    "frmaboutEMAIL": "Email",
    "frmaboutWEBSITE": "Website",
    "frmaboutMOBILE": "Mobile",
    "frmaboutAUTHOR": "Author",
    "frmaboutDESCRIPTION": "Description",
    "frmSearch": "Search",
    "frmToc": "Table Of Contents",
    "btnTableOfContent": "Table Of Contents",
    "btnNote": "Annotation",
    "lblLast": "This is the last page.",
    "lblFirst": "This is the first page.",
    "lblFullscreen": "Click to view in fullscreen",
    "lblName": "Name",
    "lblPassword": "Password",
    "lblLogin": "Login",
    "lblCancel": "Cancel",
    "lblNoName": "User name can not be empty.",
    "lblNoPassword": "Password can not be empty.",
    "lblNoCorrectLogin": "Please enter the correct user name and password.",
    "btnVideo": "Video Gallery",
    "btnSlideShow": "Slideshow",
    "pnlSearchInputInvalid": "The search text is too short.",
    "btnDragToMove": "Move by mouse drag",
    "btnPositionToMove": "Move by mouse position",
    "lblHelp1": "Drag the page corner to view",
    "lblHelp2": "Double click to zoom in, out",
    "lblCopy": "Copy",
    "lblAddToPage": "Add To Page",
    "lblPage": "Page",
    "lblTitle": "Title",
    "lblEdit": "Edit",
    "lblDelete": "Delete",
    "lblRemoveAll": "Remove All",
    "tltCursor": "Cursor",
    "tltAddHighlight": "Add highlight",
    "tltAddTexts": "Add texts",
    "tltAddShapes": "Add shapes",
    "tltAddNotes": "Add notes",
    "tltAddImageFile": "Add image file",
    "tltAddSignature": "Add signature",
    "tltAddLine": "Add line",
    "tltAddArrow": "Add arrow",
    "tltAddRect": "Add rect",
    "tltAddEllipse": "Add ellipse",
    "lblDoubleClickToZoomIn": "Double click to zoom in.",
    "lblPages": "Pages",
    "infCopyToClipboard": "Your browser dose not support clipboard, please do it yourself.",
    "lblDescription": "Title",
    "frmLinkLabel": "Link",
    "infNotSupportHtml5": "HTML5 is not supported by your current web browser, please read the catalogue with latest verson web browser. Here we recommend you to read it with Safari.",
    "frmHowToUse": "How To Use",
    "lblHelpPage1": "Move your finger to flip the catalogue page.",
    "lblHelpPage2": "Zoom in by using gesture or double click on the page.",
    "lblHelpPage3": "Click to view the table of content, bookmarks and share the catalogue via social networks.",
    "lblHelpPage4": "Add bookmarks, use search function and auto flip the catalogue.",
    "lblHelpPage5": "Open the thumbnails to overview all catalogue pages.",
    "frmQrcodeCaption": "Scan the bottom two-dimensional code to view with mobile phone.",
    "btnPageBack": "Backward",
    "btnPageForward": "Forward",
    "btnLanguage": "Change Language",
    "msgConfigMissing": "Configuration file is missing, unable to open the catalogue."
},
{
    "language": "Türkçe",
    "btnFirstPage": "İlk",
    "btnNextPage": "Sonraki",
    "btnLastPage": "Son",
    "btnPrePage": "Önceki",
    "btnGoToHome": "Anasayfa",
    "btnDownload": "İndir",
    "btnSoundOn": "Sesi Aç",
    "btnSoundOff": "Sesi Kapat",
    "btnPrint": "Yazdır",
    "btnThumb": "Küçük resimler",
    "btnBookMark": "Favorile",
    "frmBookMark": "Favorile",
    "btnZoomIn": "Yaklaştır",
    "btnZoomOut": "Uzaklaştır",
    "btnAutoFlip": "Otomatik devam et",
    "btnStopAutoFlip": "Otomatik devam etmeyi durdur",
    "btnSocialShare": "Paylaş",
    "btnHelp": "Yardım",
    "btnAbout": "Hakkında",
    "btnSearch": "Arama",
    "btnFullscreen": "Tam ekran",
    "btnExitFullscreen": "Tam ekrandan çık",
    "btnMore": "Daha fazla",
    "frmPrintCaption": "Yazdır",
    "frmPrintall": "Tüm sayfaları yazdır",
    "frmPrintcurrent": "Mevcut sayfayı yazdır",
    "frmPrintRange": "Yazdırma aralığı belirle",
    "frmPrintexample": "Örnek: 2,3,5-10",
    "frmPrintbtn": "Yazdır",
    "frmShareCaption": "Paylaş",
    "frmShareLabel": "Paylaş",
    "frmShareInfo": "Bu kataloğu sosyal medya platformlarında kolaylıkla paylaşabilirsiniz. Sadece aşağıdan uygun yere tıklayın.",
    "frminsertLabel": "Sitenize ekleyin",
    "frminsertInfo": "Aşağıdaki kodu kullanarak bu kataloğu internet sitenize ekleyebilirsiniz.",
    "frmaboutcaption": "İletişim",
    "frmaboutcontactinformation": "İletişim bilgileri",
    "frmaboutADDRESS": "Adres",
    "frmaboutEMAIL": "E posta",
    "frmaboutWEBSITE": "İnternet sitesi",
    "frmaboutMOBILE": "Mobil",
    "frmaboutAUTHOR": "Yazar",
    "frmaboutDESCRIPTION": "Açıklama",
    "frmSearch": "Arama",
    "frmToc": "İçindekiler",
    "btnTableOfContent": "İçindekiler",
    "btnNote": "Dipnotlar",
    "lblLast": "Bu son sayfa.",
    "lblFirst": "Bu ilk sayfa.",
    "lblFullscreen": "Tam ekranda görüntülemek için tıklayın",
    "lblName": "Ad",
    "lblPassword": "Şifre",
    "lblLogin": "Giriş",
    "lblCancel": "İptal",
    "lblNoName": "Kullanıcı adı boş olamaz.",
    "lblNoPassword": "Şifre boş olamaz.",
    "lblNoCorrectLogin": "Lütfen doğru kullanıcı adı ve şifre girdiğinizden emin olun.",
    "btnVideo": "Video galerisi",
    "btnSlideShow": "Slayt gösterisi",
    "pnlSearchInputInvalid": "Arama metni çok kısa.",
    "btnDragToMove": "Farenizi sürükleyek kaydırın",
    "btnPositionToMove": "Fare konumunu kullanarak kaydırın",
    "lblHelp1": "Sayfa köşesinden ekrana sürükleyin",
    "lblHelp2": "Yakınlaşıp uzaklaşmak için çift tıklayın",
    "lblCopy": "Kopyala",
    "lblAddToPage": "Sayfaya ekle",
    "lblPage": "Sayfa",
    "lblTitle": "Başlık",
    "lblEdit": "Düzenle",
    "lblDelete": "Sil",
    "lblRemoveAll": "Hepsini kaldır",
    "tltCursor": "Fare ucu",
    "tltAddHighlight": "Vurgu ekle",
    "tltAddTexts": "Metin ekle",
    "tltAddShapes": "Şekil ekle",
    "tltAddNotes": "Not ekle",
    "tltAddImageFile": "Fotoğraf dosyası ekle",
    "tltAddSignature": "İmza ekle",
    "tltAddLine": "Çizgi ekle",
    "tltAddArrow": "Ok ekle",
    "tltAddRect": "Dikdörtgen ekle",
    "tltAddEllipse": "Elips ekle",
    "lblDoubleClickToZoomIn": "Yaklaşmak için çift tıklayın.",
    "lblPages": "Sayfalar",
    "infCopyToClipboard": "Tarayıcınız kopyala geçmişini desteklemiyor, lütfen kendiniz yapınız.",
    "lblDescription": "Başlık",
    "frmLinkLabel": "Bağlantı",
    "infNotSupportHtml5": "HTML5 mevcut tarayıcınız tarafından desteklenmemekte, lütfen kataloğu tarayıcınızın en son sürümüyle kullanın. Burada Safari kullanmanızı öneriyoruz.",
    "frmHowToUse": "Nasıl kullanılır",
    "lblHelpPage1": "Sayfa değiştirmek için parmağınızı kullanın.",
    "lblHelpPage2": "İki parmağınızı birbirinden uzaklaştırarak ya da ekrana çift tıklayarak yakınlaşabilirsiniz.",
    "lblHelpPage3": "İçindekiler, favoriler ve kataloğu sosyal medyada paylaşmak için tıklayın.",
    "lblHelpPage4": "Favoriler ekleyin, arama fonksiyonunu ve otomatik çevirme özelliğini kullanın.",
    "lblHelpPage5": "Tüm sayfaları görmek için küçük resimleri açın.",
    "frmQrcodeCaption": "Telefonunuzla kataloğa erişmek için iki boyutlu kodu okutun.",
    "btnPageBack": "Geri",
    "btnPageForward": "İleri",
    "btnLanguage": "Dili değiştir",
    "msgConfigMissing": "Konfigürasyon dosyası eksik, katalog yüklenemiyor."
}];;
var pageEditor = [];
var ols = [];
var slideshow = [];
var videoList = [];
var bmtConfig = {
    "tabs": [],
    "onSideEdge": true
};
var staticAd = {};
var flipByAudio = {};
var bookPlugin = null;
var phoneNumber = [];
